import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-caption font-weight-bold" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "pa-4 pt-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "text-center ma-0" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDays, (day) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: day,
                  cols: 12 / 7,
                  class: "text-caption text-grey-darken-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(day), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weeks, (week, wIdx) => {
              return (_openBlock(), _createBlock(_component_v_row, {
                key: wIdx,
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week, (day) => {
                    return (_openBlock(), _createBlock(_component_v_col, {
                      key: day.date,
                      cols: 12 / 7,
                      class: _normalizeClass(["pa-1 border", {
                'today-overlay': _ctx.isToday(day.date),
                'outside-month': day.isOutsideMonth
              }]),
                      style: {"min-height":"100px"},
                      onMousedown: ($event: any) => (_ctx.startRangeSelection(day)),
                      onMouseup: ($event: any) => (_ctx.endRangeSelection(day)),
                      onClick: ($event: any) => (_ctx.handleSingleClick(day))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, _toDisplayString(day.day), 1),
                        (_ctx.events.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getEventsForDate(day.date), (event) => {
                                return (_openBlock(), _createBlock(_component_v_chip, {
                                  key: event.id,
                                  color: event.color || 'background: rgb(0 0 0 / 20%);',
                                  size: "x-small",
                                  class: "ma-1",
                                  onClick: _withModifiers(() => _ctx.onView?.(event), ["stop"]),
                                  onMousedown: _withModifiers(() => _ctx.onView?.(event), ["stop"]),
                                  onMouseup: _withModifiers(() => _ctx.onView?.(event), ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.formatTime(event.date)) + " - " + _toDisplayString(event?.original?.subject?.attributes?.commercial_name || event?.original?.subject?.attributes?.legal_name || event?.original?.subject?.attributes?.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color", "onClick", "onMousedown", "onMouseup"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["class", "onMousedown", "onMouseup", "onClick"]))
                  }), 128))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}